export type ITimeSlot = {
  // 24h value used for selection/sorting, e.g. "09:15"
  value: string;
  // Display label shown in the grid, e.g. "09:15AM"
  label: string;
};

export type ITimeGroup = {
  title: 'Morning' | 'Afternoon' | 'Evening';
  slots: ITimeSlot[];
};

const pad = (n: number) => String(n).padStart(2, '0');

const parseHHmm = (raw: string): number | null => {
  const match = /^(\d{1,2}):(\d{2})/.exec((raw || '').trim());
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
};

const toLabel = (totalMinutes: number): string => {
  const hour24 = Math.floor(totalMinutes / 60);
  const minute = totalMinutes % 60;
  const period = hour24 >= 12 ? 'PM' : 'AM';
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return `${pad(hour12)}:${pad(minute)}${period}`;
};

const toValue = (totalMinutes: number): string => `${pad(Math.floor(totalMinutes / 60))}:${pad(totalMinutes % 60)}`;

// Group raw "HH:mm" timeslots (from the API) into parts of the day.
export const buildTimeGroups = (rawTimes: string[] = []): ITimeGroup[] => {
  const buckets: Record<ITimeGroup['title'], ITimeSlot[]> = {
    Morning: [],
    Afternoon: [],
    Evening: [],
  };
  rawTimes.forEach((raw) => {
    const minutes = parseHHmm(raw);
    if (minutes == null) return;
    const slot: ITimeSlot = { value: toValue(minutes), label: toLabel(minutes) };
    if (minutes < 12 * 60) buckets.Morning.push(slot);
    else if (minutes < 17 * 60) buckets.Afternoon.push(slot);
    else buckets.Evening.push(slot);
  });
  return [
    { title: 'Morning', slots: buckets.Morning },
    { title: 'Afternoon', slots: buckets.Afternoon },
    { title: 'Evening', slots: buckets.Evening },
  ];
};
